import DOMPurify from "dompurify";

/**
 * Sanitizes an HTML string to make it safe for use in `dangerouslySetInnerHTML`.
 * This function uses `DOMPurify` to remove potentially dangerous content
 * while preserving any legitimate HTML content (like tags for formatting).
 *
 * @param {string} htmlString - The HTML string to be sanitized.
 * @returns {object} An object with the `__html` property containing the sanitized HTML string.
 */
const createSafeHTML = (htmlString: string) => {
  return { __html: DOMPurify.sanitize(htmlString) };
};

export default createSafeHTML;

// TODO use this function instead of redeclaring in every component
